
export default {
    columns: {
        itemNames: {
            label: "商品",
            visible: true,
            width: "auto",
            align: "left",
        },
        mobile: {
            label: "手机号码",
            visible: true,
            width: "auto",
            align: "left",
        },
        staffNames: {
            label: "店员",
            visible: true,
            width: "auto",
            align: "left",
        },
        itemNum: {
            label: "物品数量",
            visible: true,
            width: "auto",
            align: "left",
        },
        statusCn: {
            label: "订单状态",
            visible: true,
            width: "auto",
            align: "left",
        },
        oxCtime: {
            label: "寄存时间",
            visible: true,
            formatDay: true,
            width: "auto",
            align: "left",
        },
    },
};